/*globals ajaxurl, wpmlCFInfo, wpApiSettings */
import fetch from 'cross-fetch';
/** @see https://atomiks.github.io/tippyjs/ */
import tippy from 'tippy.js';

/** @namespace wpmlCFInfo.strings.originalLabel */
/** @namespace wpmlCFInfo.nonces.getInfo */

class CustomFieldInfo {
	constructor(element) {
		this.element = element;

		this.id = this.element.id.split('-')[1];
		this.targets = this.element.querySelectorAll('textarea');
	}

	init() {
		const queryString = require('query-string');
		const urlQueryString = {
			[wpmlCFInfo.nonces.getInfo.name]: wpmlCFInfo.nonces.getInfo.value,
			action:                           'wpml_cf_get_info',
			meta_id:                          this.id,
		};

		fetch(`${ajaxurl}?${queryString.stringify(urlQueryString)}`, {
			method:  "GET",
			headers: {
				'Content-Type': 'application/json',
				'X-WP-Nonce':   wpApiSettings.nonce,
			},
		})
			.then(response => response.json())
			.then(json => {
				if (json.success && json.data.value) {
					this.addToolTips(json.data);
				}
			});
	}

	addToolTips(info) {
		Array.from(this.targets).map(function (element) {

			element.setAttribute('title', `${wpmlCFInfo.strings.originalLabel} <strong>${info.value}</strong>`);

			tippy(element, {
				theme:         'wpml',
				trigger:       'click',
				interactive:   true,
				arrow:         true,
				appendTo:      element.parentNode,
				popperOptions: {
					modifiers: {
						preventOverflow: {
							enabled: false,
						},
						hide:            {
							enabled: false,
						},
					},
				},
			});
		});
	}
}

export default CustomFieldInfo;


// WEBPACK FOOTER //
// ./js/post-meta/CustomFieldInfo.js